import React from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Button } from 'react-bootstrap';

export default function DeleteButton({ productId }) {
  const history = useHistory();
  // const product = Object.values(productId);

  function deleteProduct(e) {
    e.preventDefault();

    fetch(
      `https://sheltered-badlands-71188.herokuapp.com/api/v1/product/${productId}`,
      {
        method: 'PATCH',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);

        if (data) {
          Swal.fire({
            title: 'Successful',
            icon: 'success',
            text: 'The course is deleted',
          });

          window.location.reload();
          // .then(() => history.go(0));
        } else {
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: 'Failed to delete a course',
          });
        }
      });
  }

  return (
    <Button variant='danger' onClick={deleteProduct}>
      Delete
    </Button>
  );
}
